import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { Subject } from 'rxjs';
import { AlertService } from 'src/app/_services/alert.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import * as moment from 'moment';
import { RequestService } from 'src/app/_services/request.service';

@Component({
  selector: 'app-SicknessRequest',
  templateUrl: './SicknessRequest.component.html',
  styleUrls: [
    './SicknessRequest.component.css',
    '../RequestModal/RequestPermission.component.css',
    '../../review-modal/review-modal.component.css'
  ]
})
export class SicknessRequestComponent extends BaseComponent implements OnInit {
  @Output() saved = new EventEmitter<any>();
  sicknessForm: FormGroup;
  private readonly alertService: AlertService = inject(AlertService);
  public rs: RequestService = inject(RequestService);

  // input arrivati dal componente Calendar
  readonly modalData: any = inject(NZ_MODAL_DATA);

  request?: any;
  user: any;
  date: string;

  private readonly destroy$: Subject<void> = new Subject<void>();
  public formBuilder: FormBuilder = inject(FormBuilder);

  constructor(private readonly modalRef: NzModalRef) {
    moment.locale('it');
    super();
  }

  ngOnInit() {
    this.request = this.modalData.request;
    this.user = this.modalData.user;
    this.date = this.modalData.date;

    this._initForm();
  }

  /**
   * Inizializzo il form
   */
  _initForm() {
    this.sicknessForm = this.formBuilder.group({
      event_type_id: 6,
      date: this.date
        ? moment(this.date).format('DD MMMM YYYY')
        : moment().format('DD MMMM YYYY'),
      notes: new FormControl(null, Validators.required)
    });
  }

  /**
   * limita il testo della descrizione non oltre i 150 caratteri
   */
  limitTextLength(): void {
    const control = this.sicknessForm.get('note');
    if (control) {
      const text = control.value ?? '';
      if (text.length > 249) {
        control.setValue(text.substring(0, 250), { emitEvent: false });
      }
    }
  }

  saveSicknessRequest() {
    const formData = this.sicknessForm.value;
    const requestDate = this.date ? moment(this.date) : moment();
    const payload = {
      ...formData,
      user_id: this.user?.id,
      date_array: [
        {
          startDate: requestDate.format('YYYY/MM/DD'),
          start_time: '09:00',
          end_time: '18:00'
        }
      ]
    };
    // cancello dati che non voglio passare al BE
    delete payload.date;

    this.rs.storeRequest(payload).subscribe({
      next: () => {
        // Richiamo l'alert direttamente nell'AlertService
        let text = 'di malattia';
        this.alertService.showSuccessRequestAlert(text, this.date);
        //Chiudo la modale
        this.saved.emit({ success: true, date: requestDate.toDate() });
        this.modalRef.close();
      },
      error: err => {
        this.alertService.showErrorRequestAlert();
      }
    });
  }

  closeModal() {
    this.modalRef.close();
  }
}
